var Service       = require("app/Domain/Ott/Api/V2/Service"),
    config        = require("app/config"),
    kind          = require("enyo/kind"),
    logger        = require("enyo/logger"),
    quickMacroize = require("enyo/macroize").quickMacroize;

/**
 * This service manages the current user's data.
 */
module.exports = kind.singleton(/** @lends app.Domain.Ott.Api.V2.DataAccess.User.Service.prototype */ {

    /**
     * @private
     */
    name: "app.Domain.Ott.Api.V2.DataAccess.User.Service",

    /**
     * @private
     */
    kind: Service,

    /**
     * @type {Array}
     * @private
     */
    mutableProperties: ["email", "password", "is_adult", "preview_mode", "language"],

    // API
    // --------------------------------

    /**
     * Attempt to change the user's profile.
     *
     * @param    {Object}   changes   Key-value pairs to patch the profile with
     * @param    {?string}  password  Optional verification by password
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    changeProfile: function(changes, password) {
        var key     = ["user", "me"].join("/"),
            task    = this.tasks[key],
            endpoint,
            payload = {};

        if (!task) {
            endpoint = new URL(quickMacroize("{$ottApi}/user/me", {
                ottApi: config.ottApi.url
            }));

            // Supported properties
            this.mutableProperties.forEach(function(prop) {
                if (changes.hasOwnProperty(prop)) {
                    payload[prop] = changes[prop];
                }
            });

            task = this.tasks[key] = this._put(endpoint.toString(), {
                data:     payload,
                password: password
            });

            task.promise
                .then(this.bindSafely(function(response) {
                    return response;
                }))
                .catch(this.bindSafely(function(error) {
                    logger.error(error);

                    if (typeof Sentry !== "undefined" && error instanceof Error) {
                        Sentry.captureException(error);
                    }

                    return Promise.resolve({
                        status: "rejected",
                        type:   "task_rejected",
                        error:  error
                    });
                }))
                .finally(this.bindSafely(function() {
                    delete this.tasks[key];
                }));
        }

        return task.promise;
    },

    /**
     * Remove the current user's account.
     *
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    removeAccount: function() {
        var key  = ["user", "me", "remove-account"].join("/"),
            task = this.tasks[key],
            endpoint;

        if (!task) {
            endpoint = new URL(quickMacroize("{$ottApi}/user/me/remove-account", {
                ottApi: config.ottApi.url
            }));

            task = this.tasks[key] = this._post(endpoint.toString());

            task.promise
                .then(this.bindSafely(function(response) {
                    return response;
                }))
                .catch(this.bindSafely(function(error) {
                    logger.error(error);

                    if (typeof Sentry !== "undefined" && error instanceof Error) {
                        Sentry.captureException(error);
                    }

                    return Promise.resolve({
                        status: "rejected",
                        type:   "task_rejected",
                        error:  error
                    });
                }))
                .finally(this.bindSafely(function() {
                    delete this.tasks[key];
                }));
        }

        return task.promise;
    }

});
